module.exports = __webpack_public_path__ + "img/advanced_enterprise.8f71cdb9.png";